import React from 'react';

import PayeePopup from 'apps/auth/components/common/send/popups/PayeePopup/PayeePopup';
import { CALCULATOR_SCREEN } from 'apps/auth/components/send/SendConstants';
import { PERSONAL } from 'apps/auth/constants/Constants';
import { AMOUNT_FROM, AMOUNT_TO, PLACEHOLDER, TO_RECIPIENT } from 'apps/auth/constants/fieldsName';
import { logInfo } from 'apps/auth/helpers/clientLogger';

type FieldEntry = {
    value?: unknown;
};

type FieldsMap = Record<string, FieldEntry | undefined>;

type ChangeFormFieldValue = (formName: string | Record<string, unknown> | undefined, value: unknown, fieldName: string) => void;

type ChangeFieldProperty = (formName: string, fieldName: string, propertyName: string, value: string) => void;

type PayeeExtra = {
    textFirstPopup?: string;
    warning?: string;
    [key: string]: unknown;
};

type PayeePopupExtra = PayeeExtra & {
    textFirstPopup: string;
};

type PayeeResponse = {
    extra?: PayeeExtra;
};

type AddExtras = (extra: PayeeExtra) => Promise<{ extra: PayeeExtra }>;

type PayeePopupRef = React.RefObject<{ open: (content: React.ReactNode) => void }>;

type PayeeProps = {
    addExtras: AddExtras;
    changeFormFieldValue: ChangeFormFieldValue;
    fields?: FieldsMap;
};

const clearingFields = (changeFormFieldValue: ChangeFormFieldValue, formName: string | Record<string, unknown> | undefined, fields: FieldsMap = {}) => {
    const amountFrom = fields[AMOUNT_FROM];
    const amountTo = fields[AMOUNT_TO];
    if (amountFrom?.value) {
        changeFormFieldValue(formName, null, AMOUNT_FROM);
    }
    if (amountTo?.value) {
        changeFormFieldValue(formName, null, AMOUNT_TO);
    }
};

const usePayee = (
    json: PayeeResponse,
    setScreen: ((screen: string) => void) | undefined,
    formName: string,
    isTransfers: boolean,
    props: PayeeProps,
    popupRef?: PayeePopupRef,
    resetViewRatesFirst?: () => void,
    sendParamToStateMachine?: (...args: any[]) => void,
): void => {
    if (json.extra) {
        void props.addExtras(json.extra).then(({ extra }) => {
            const setNextScreen = setScreen ?? (() => {});
            if (extra.textFirstPopup) {
                const popupExtra = extra as PayeePopupExtra;
                popupRef?.current?.open(
                    <PayeePopup
                        popupRef={popupRef}
                        extra={popupExtra}
                        setNextScreen={setNextScreen}
                        sendParamToStateMachine={sendParamToStateMachine}
                        formName={formName}
                        isTransfers={isTransfers}
                        resetViewRatesFirst={resetViewRatesFirst}
                    />,
                );
                clearingFields(props.changeFormFieldValue, props.fields);
            } else {
                if (extra.warning) {
                    if (__isDev__) {
                        logInfo(extra.warning);
                    }
                }
                clearingFields(props.changeFormFieldValue, formName, props.fields);
                setNextScreen(CALCULATOR_SCREEN);
            }
        });
    }
};
const selectHandlerPayee = ({
    item,
    personalPlaceholder,
    businessPlaceholder,
    changeFieldProperty,
    formName,
}: {
    item: { value?: string };
    personalPlaceholder: string;
    businessPlaceholder: string;
    changeFieldProperty: ChangeFieldProperty;
    formName: string;
}): void => {
    const newPlaceholder = item.value === PERSONAL ? personalPlaceholder : businessPlaceholder;
    changeFieldProperty(formName, TO_RECIPIENT, PLACEHOLDER, newPlaceholder);
};
export { selectHandlerPayee, usePayee };
